// AI Generated Test
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { SeoRepoService } from '@client/app/services/api/seo-repo/seo-repo.service';
import { PageRepoService } from '@client/app/services/api/page-repo/page-repo.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';

@Component({
    selector: 'page-details-dashboard-charts-seo',
    standalone: false,
    template: `
        <div class="row align-items-center">
            <div class="offset-4 col-18 page-dashboard-doughnut-container">
                <mon-chart-doughnut [labels]="doughnutLabels" [data]="doughnutData" [options]="doughnutOptions"
                                [colors]="colors">
                </mon-chart-doughnut>
            </div>
            <div class="col-26 pl-0">
                <notification-change [title]="'SEO Issues' | translate"
                                   (click)="onClickHandler.emit({params: {target: pageDetailsSectionSeo}})"
                                   [digit]="issuesOnThisPage">
                </notification-change>
                <ul class="list-inline pl-4 my-1">
                    <li ngbTooltip="{{ 'High impact opportunities' | translate }}"
                        [triggers]="'focus hover'"
                        (click)="onClickHandler.emit({params: {target: pageDetailsSectionSeo}})">
                    <span class="fas fa-chart-line fa-lg"
                          [ngClass]="{ 'text-danger': seoClassifications[1] > 0, 'text-grey': seoClassifications[1] <= 0}"></span>
                        {{seoClassifications[1] | monNumber}}
                    </li>
                    <li ngbTooltip="{{ 'Medium impact opportunities' | translate }}"
                        [triggers]="'focus hover'"
                        (click)="onClickHandler.emit({params: {target: pageDetailsSectionSeo}})">
                    <span class="fas fa-chart-line fa-lg"
                          [ngClass]="{ 'text-warning': seoClassifications[2] > 0, 'text-grey': seoClassifications[2] <= 0}"></span>
                        {{seoClassifications[2] | monNumber}}
                    </li>
                    <li ngbTooltip="{{ 'Low impact opportunities' | translate }}"
                        [triggers]="'focus hover'"
                        (click)="onClickHandler.emit({params: {target: pageDetailsSectionSeo}})">
                    <span class="fas fa-chart-line fa-lg"
                          [ngClass]="{ 'text-info': seoClassifications[3] > 0, 'text-grey': seoClassifications[3] <= 0}"></span>
                        {{seoClassifications[3] | monNumber}}
                    </li>
                    <li ngbTooltip="{{ 'Technical SEO Issues' | translate }}"
                        [triggers]="'focus hover'"
                        (click)="onClickHandler.emit({params: {target: pageDetailsSectionSeo}})">
                    <span class="fas fa-chart-line fa-lg"
                          [ngClass]="{ 'text-primary': seoClassifications[4] > 0, 'text-grey': seoClassifications[4] <= 0}"></span>
                        {{seoClassifications[4] | monNumber}}
                    </li>
                </ul>
            </div>
        </div>
    `,
})
export class PageDetailsDashboardChartsSeoComponent implements OnInit {
    @Input() page: any;
    @Output() onClickHandler = new EventEmitter<any>();

    issuesOnThisPage: number = 0;
    pageDetailsSectionSeo: any;
    doughnutLabels: any[] = [];
    doughnutData: any[] = [];
    doughnutOptions: any = {};
    colors: string[] = [];
    totalSeoIssues: number = 0;
    percentage: number = 0;
    seoClassifications: any = {};

    constructor (
        private seoRepoService: SeoRepoService,
        private pageRepoService: PageRepoService,
        private pipeService: PipeService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.issuesOnThisPage = 0;
        this.pageDetailsSectionSeo = 'SEO';
        this.setupDoughnutChart();
        this.getSeoIssues();
    }

    private setupDoughnutChart (): void {
        const params: any = {
            page_id: this.page.id,
            page: 1,
            page_size: 1,
        };
        this.doughnutLabels = ['', ''];
        this.colors = ['#4dc0bd', '#dcdcdc'];

        this.seoRepoService.getAll(params).then((data: any) => {
            this.totalSeoIssues = data.total;
            this.percentage = (this.page.seo_issues_count / this.totalSeoIssues) * 100;
            this.doughnutData = [this.totalSeoIssues - this.page.seo_issues_count, this.page.seo_issues_count];
            this.doughnutOptions = {
                centerText: {
                    percentageLabel: this.pipeService.get('monNumber')((100 - this.percentage) / 100, '0.[00] %'),
                },
                cutoutPercentage: 80,
                tooltips: {
                    enabled: this.totalSeoIssues > 0,
                    callbacks: {
                        beforeLabel: (tooltipItem: any, chartData: any) => {
                            return '';
                        },
                        label: (tooltipItem: any, chartData: any) => {
                            return this.pipeService.get('monNumber')(
                                chartData.datasets[tooltipItem.datasetIndex].data[tooltipItem.index],
                                '0,0',
                            );
                        },
                    },
                },
            };
        }).catch(() => {
            // Handle error silently like angular.noop
        });
    }

    private getSeoIssues (): void {
        this.seoClassifications = {
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
        };

        this.pageRepoService.getSeoIssues(this.page.id).then((data: any) => {
            const pageSeoIssues = data.filter((seo: any) => {
                const issueNotFixed = seo.issues.find((seoIssue: any) => {
                    // Find at least one issue that is not ignored or fixed
                    return seoIssue.marked_as_fixed_at === null && seoIssue.ignored_at === null;
                });

                return issueNotFixed !== undefined;
            });
            pageSeoIssues.forEach((seo: any) => {
                this.seoClassifications[seo.classification] += 1;
            });
            this.issuesOnThisPage = pageSeoIssues.length;
        }).catch(() => {
            // Handle error silently like angular.noop
        });
    }
}
